import { createPortal } from "react-dom";
import { FC, ReactNode, useLayoutEffect, useState } from "react";

interface PortalProps {
  wrapperId: string;
  children?: ReactNode;
}

const Portal: FC<PortalProps> = ({ wrapperId = "react-portal-wrapper", children }) => {
  const [wrapperElement, setWrapperElement] = useState<HTMLElement | null>(null);

  useLayoutEffect(() => {
    let element = document.getElementById(wrapperId);
    let systemCreated = false;
    if (!element) {
      systemCreated = true;
      element = createWrapperAndAppendToBody(wrapperId);
    }
    setWrapperElement(element);

    return () => {
      // delete the programatically created element
      if (systemCreated && element && element.parentNode) {
        element.parentNode.removeChild(element);
      }
    };
  }, [wrapperId]);

  const createWrapperAndAppendToBody = (wrapperId: string) => {
    const wrapperElement = document.createElement("div");
    wrapperElement.setAttribute("id", wrapperId);
    document.body.appendChild(wrapperElement);
    return wrapperElement;
  };

  if (wrapperElement === null) return null;

  return createPortal(children, wrapperElement);
};

export default Portal;
